// Decodes a GraphQL global ID and extracts the underlying 24-char Mongo
// ObjectID. Falls back to the input if it's not encoded or can't be decoded.
export const extractMongoId = (globalId: string): string => {
  try {
    const decoded = atob(globalId.replace(/-/g, "+").replace(/_/g, "/"));
    const match = decoded.match(/[a-f0-9]{24}$/i);
    return match ? match[0] : globalId;
  } catch {
    return globalId;
  }
};
